<template>
    <vs-popup classContent="popup-example"  title="افزودن مقاله جدید" :active.sync="showPopup">
        <!-- <form class="p-4" @keydown.enter="addArticleInfo()"> -->
        <form class="px-4" id="newPopup" ref="newPopup">
            <div class="vx-row px-5 mb-4">
                <div class="vx-col w-1/2">
                    <label class="vs-input--label">عنوان</label>
                    <vs-input class="w-full mt-2" v-model="title" />
                </div>
                <div class="vx-col w-1/2 upload-btn-wrapper">
                    <label class="vs-input--label">آپلود عکس</label>
                    <b-form-file
                        v-model="file"
                        placeholder="Choose a file or drop it here..."
                        drop-placeholder="Drop file here..."
                        class="mt-2"
                        accept="image/*"
                    />
                    <!-- <input type="file" id="file" ref="file" @change="uploadImg()" /> -->
                </div>
                <div class="vx-col w-full mt-4">
                    <label class="vs-input--label">توضیحات</label>
                    <quill-editor v-model="text"></quill-editor>
                    <!-- <vs-textarea v-model="text" rows="4" /> -->
                </div>
            </div>

            <vs-row class="mt-4" vs-w="12" vs-type="flex" vs-justify="center">
                <vs-col class="sm:w-1/2 w-full">
                    
                </vs-col>
                <vs-col class="sm:w-1/2 w-full">
                    <vs-button class="mr-3 float-right" @click="addArticleInfo()">ثبت</vs-button>
                </vs-col>
            </vs-row>
        </form>
    </vs-popup>
</template>

<script>
import { BFormFile } from 'bootstrap-vue'
import { Validator } from 'vee-validate';

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
const dict = {
    custom: {
    }
};

// register custom messages
Validator.localize('en', dict);

export default {
    name: 'AddArticle',

    props: {
        popupAddArticle: {
            type: Boolean,
            default: false,
        },
    },
    
    components: {
        BFormFile,
        quillEditor
    },
    
    data() {
		return{
            showPopup: false,
            file: [],
            title: '',
            thumbnail: '',
            text: '',
		}
    },
    
    computed: {
    },

    watch: { 
      	popupAddArticle: function(newVal) {
            this.showPopup = newVal
        },

        showPopup: function(newVal) {
            this.$emit('updatePopupAddArticle', newVal)
            this.title = ''
            this.thumbnail = ''
            this.text = ''
        }
    },

    created(){
    },

    mounted() {
    },

    updated() {
        // this.$nextTick(() => {
        //         var elmnt = document.getElementById("newPopup");
        //         var y = elmnt.scrollHeight;
        //         console.log(y)
        //         document.getElementById("newPopup").scrollTo(0,0);
        //     });
    },
    
    methods: {
        uploadImg() {
            this.file = this.$refs.file.files[0];
        },

        addArticleInfo() {
            this.$vs.loading()
            let formData = new FormData();
            formData.append('thumbnail', this.file);
            formData.append('title', this.title);
            formData.append('text', this.text);
            formData.append('order', 0);
            formData.append('type', 'article');
            this.$emit('updatePopupAddArticle', false)

            // let type = 'article'
            
            this.$store.dispatch('addPost', formData)
			.then(() => {
                this.$vs.loading.close()
                this.$vs.notify({
					title: '',
					text: 'مقاله با موفقیت افزوده شد.',
					iconPack: 'feather',
					icon: 'icon-check-square',
					color: 'success'
				})
            })
            .catch(() => {
                this.$vs.loading.close()
                this.$vs.notify({
                    title: '',
                    text: 'اطلاعات ارسالی صحیح نمی باشد.',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
				})
			})
        }
    }
}
</script>

<style scope>
.con-vs-popup .vs-popup {
    width: 50% !important;
}

.upload-btn-wrapper {
    position: relative;
    overflow: hidden;
    display: inline-block;
}
</style>